import { DATA_SELECTOR_ID, FOCUS_PREDICTION_CLASS, storeSearchInfo } from "../utils/context-layer-variables";
import { fetchStoresAroundRendering, initStoreSearchResultEvents } from "./store-search";
import { StoreSearchData } from "../models/StoreSearchData";
import { CustomerContext } from "../models/CustomerContext";
import { clearErrorMessage, insertErrorMessage } from "./search-errors";
import { sendCdlEventOnStepDisplay } from "./tracking";
import { fetchStorePredictionsService } from "../api/store-predictions-service";
import { Localities } from "../models/Localities";
import { Locality } from "../models/Locality";
import { ShortCoordinates } from "../models/shortCoordinates";
import { initDecreasedViewListener } from "./decreased-store-search";
let timeoutID = 0;
let storeSearchInputContainer;
let searchPredictionsContainer;
export function initAutocompletePredictionEvents(storeSearchContainer) {
  storeSearchInputContainer = storeSearchContainer.querySelector(`input[name="contextLayerSearchInput"]`);
  searchPredictionsContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="search-predictions"]`);
  storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.addEventListener('input', event => {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      const input = storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.value;
      if (input) {
        generateStorePredictions(input, storeSearchContainer);
      } else {
        if (searchPredictionsContainer) searchPredictionsContainer.style.display = 'none';
        storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.setAttribute('aria-expanded', 'false');
      }
    }, 250, event);
  });
  const storeSearchForm = storeSearchContainer === null || storeSearchContainer === void 0 ? void 0 : storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="store-search-form"]`);
  storeSearchForm === null || storeSearchForm === void 0 ? void 0 : storeSearchForm.addEventListener('submit', event => {
    event.preventDefault();
    return false;
  });
  document.addEventListener('click', event => {
    if (event.target !== storeSearchInputContainer && event.target !== searchPredictionsContainer) {
      cleanStoreSearchPredictions();
    }
  });
  storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.addEventListener('focus', () => generateStorePredictions((storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.value) || '', storeSearchContainer).then(() => {
    const firstSearchElem = searchPredictionsContainer === null || searchPredictionsContainer === void 0 ? void 0 : searchPredictionsContainer.querySelector(`li:first-child`);
    firstSearchElem === null || firstSearchElem === void 0 ? void 0 : firstSearchElem.classList.add(FOCUS_PREDICTION_CLASS);
  }));
  storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.addEventListener('keydown', event => searchPredictionsContainer ? onInputNavigation(event, searchPredictionsContainer) : null);
  searchPredictionsContainer === null || searchPredictionsContainer === void 0 ? void 0 : searchPredictionsContainer.addEventListener('keydown', event => searchPredictionsContainer ? onPredictionsNavigation(event, searchPredictionsContainer) : null);
  storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.addEventListener('keypress', event => storeSearchInputContainer ? onInputSearch(event, storeSearchInputContainer) : null);
  if (searchPredictionsContainer) searchPredictionsContainer.style.display = 'none';
}
function convertIntoLocalitiesObject(json) {
  try {
    const parsedJson = JSON.parse(json);
    let localityList = [];
    parsedJson.localities.forEach(locality => {
      const shortCoordinates = new ShortCoordinates(locality.coordinates.lat, locality.coordinates.lng);
      localityList.push(new Locality(locality.postcode, locality.city, locality.description, shortCoordinates));
    });
    return new Localities(localityList);
  } catch (e) {
    console.error("Invalid localities object", e);
    return null;
  }
}
function generateStorePredictions(input, storeSearchContainer) {
  return new Promise(resolve => {
    fetchStorePredictionsService(input, predictions => {
      var _a;
      clearErrorMessage(storeSearchContainer);
      const localities = convertIntoLocalitiesObject(predictions);
      if (localities && ((_a = localities === null || localities === void 0 ? void 0 : localities.getLocalities()) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        renderStorePredictions(localities === null || localities === void 0 ? void 0 : localities.getLocalities(), storeSearchContainer);
        storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.focus();
        storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.setAttribute('aria-expanded', 'true');
      } else {
        if (searchPredictionsContainer) searchPredictionsContainer.style.display = 'none';
        storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.setAttribute('aria-expanded', 'false');
      }
      resolve();
    }, () => {
      insertErrorMessage(storeSearchContainer, context_layer.i18n.store_search_error);
      initDecreasedViewListener();
    });
  });
}
function onInputNavigation(event, searchPredictions) {
  const firstElemResultList = searchPredictions.querySelector(`li`);
  if (firstElemResultList) {
    switch (event.key) {
      case 'ArrowDown':
        firstElemResultList.classList.remove(FOCUS_PREDICTION_CLASS);
        firstElemResultList.focus();
        event.preventDefault();
        break;
      case 'Enter':
        firstElemResultList.focus();
        firstElemResultList.dispatchEvent(new CustomEvent('click'));
        break;
      case 'Tab':
        cleanStoreSearchPredictions();
        break;
    }
  }
}
function onPredictionsNavigation(event, searchPredictionsContainer) {
  const eventTarget = event.target;
  const currentFocusId = parseInt(eventTarget.getAttribute('id') || '');
  const nextSuggest = currentFocusId + 1;
  const prevSuggest = currentFocusId - 1;
  switch (event.key) {
    case 'ArrowDown':
      const downPredictionElem = searchPredictionsContainer.querySelector(`li[id="${nextSuggest}"]`) || searchPredictionsContainer.querySelector(`li:first-child`);
      const currentPredictionElem = searchPredictionsContainer.querySelector(`li[id="${currentFocusId}"]`);
      if (currentPredictionElem && currentPredictionElem.classList.contains(FOCUS_PREDICTION_CLASS)) {
        currentPredictionElem.classList.remove(FOCUS_PREDICTION_CLASS);
      }
      if (downPredictionElem) downPredictionElem.focus();
      event.preventDefault();
      break;
    case 'ArrowUp':
      const upPredictionElem = searchPredictionsContainer.querySelector(`li[id="${prevSuggest}"]`) || searchPredictionsContainer.querySelector(`li:last-child`);
      if (upPredictionElem) upPredictionElem.focus();
      event.preventDefault();
      break;
    case 'Tab':
      if (!searchPredictionsContainer.querySelector(`li[id="${nextSuggest}"]`)) {
        cleanStoreSearchPredictions();
      }
      break;
  }
}
export function onInputSearch(event, storeSearchInputContainer) {
  if (event.key === 'Enter') {
    const focusPrediction = storeSearchInputContainer.querySelector(`.${FOCUS_PREDICTION_CLASS}`);
    if (focusPrediction) {
      focusPrediction.click();
      storeSearchInputContainer.blur();
    }
  }
}
function cleanStoreSearchPredictions() {
  if (searchPredictionsContainer && searchPredictionsContainer.style.display !== 'none') {
    searchPredictionsContainer.style.display = 'none';
    searchPredictionsContainer.innerHTML = '';
    storeSearchInputContainer === null || storeSearchInputContainer === void 0 ? void 0 : storeSearchInputContainer.setAttribute('aria-expanded', 'false');
  }
}
function renderStorePredictions(localities, storeSearchContainer) {
  const localitiesList = localities.map((locality, index) => {
    const predictionDesc = locality.getDescription();
    const listElemLocality = document.createElement('li');
    const focusPrediction = index === 0 ? ` ${FOCUS_PREDICTION_CLASS}` : '';
    listElemLocality.setAttribute('class', 'm-store-search-predictions__elem' + focusPrediction);
    listElemLocality.setAttribute('tabindex', "0");
    listElemLocality.setAttribute('id', index.toString());
    listElemLocality.innerHTML = predictionDesc;
    listElemLocality.addEventListener('click', () => onPredictionSelection(locality, storeSearchContainer));
    listElemLocality.addEventListener('keypress', event => {
      if (event.key === 'Enter') onPredictionSelection(locality, storeSearchContainer);
    });
    return listElemLocality;
  });
  if (searchPredictionsContainer) {
    searchPredictionsContainer.replaceChildren(...localitiesList);
    searchPredictionsContainer.style.display = 'block';
  }
}
function onPredictionSelection(locality, storeSearchContainer) {
  cleanStoreSearchPredictions();
  if (storeSearchInputContainer) storeSearchInputContainer.value = locality.getDescription();
  const location = locality.getLocation();
  if (location) {
    fetchStoresAroundRendering(new StoreSearchData(location, storeSearchInfo), storeSearchContainer).then(result => {
      const customerContext = new CustomerContext(location, locality.getPostcode(), locality.getCity());
      sendCdlEventOnStepDisplay('store result');
      initStoreSearchResultEvents(customerContext, storeSearchContainer, result);
    });
  }
}